import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/app/configs/environment';
import { SUPERVISED_APPLICATION_IPS } from '../../constants/supervised-application.const';
import {
  SupervisedApplicationOption,
  SupervisedApplicationRequest,
  SupervisedApplicationResponse
} from '../../models/supervised-application/supervised-application';

@Injectable({
  providedIn: 'root'
})
export class SupervisedApplicationService {

  constructor(private _HTTP: HttpClient) { }

  // Por ahora la lista es fija; para traerla de base de datos basta con cambiar este método por un GET.
  getIps(): Observable<SupervisedApplicationOption[]> {
    return of(SUPERVISED_APPLICATION_IPS);
  }

  save(request: SupervisedApplicationRequest, file: File): Observable<SupervisedApplicationResponse> {
    const formData = new FormData();
    formData.append('solicitud', JSON.stringify(request));
    formData.append('file', file, file.name);
    return this._HTTP.post<SupervisedApplicationResponse>(`${environment.API_ORDER}/pedido/aplicacionSupervisada`, formData);
  }
}
